import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfNoteTableDto from '../dto/WhatIfNoteTableDto';

class WhatIfNoteTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfNoteTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<WhatIfNoteTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, WhatIfNoteTableDto)))
				.catch(reject);
		});
	}
}

export default new WhatIfNoteTableService();
